import React from 'react';
import {Redirect, Route, Switch,} from 'react-router-dom';

import routes from '../../routes/layouts'

const Home = () => {

  return (
    <div>

      <Switch>
        {routes.map((prop, key) => {
          if (prop.redirect) {
            return <Redirect from={prop.path} to={prop.pathTo} key={key}/>;
          }

          return (
            <Route exact path={prop.path} component={prop.component} key={key}/>
          );
        })}
      </Switch>

    </div>
  );
}

export default Home;
